import { css } from '@emotion/react';

const keyframes = css`
  transform-origin: top;

  @keyframes expandAnimation {
    0% {
      transform: scaleY(0);
    }

    100% {
      transform: scaleY(1);
    }
  }

  @keyframes collapseAnimation {
    0% {
      transform: scaleY(1);
    }

    100% {
      transform: scaleY(0);
    }
  }
`;

export const accordionAnimation = ({ show, animationDuration = 500 }) => {
  const duration = `${animationDuration}ms`;

  return show
    ? css`
        ${keyframes}
        animation: expandAnimation ${duration} ease;
      `
    : css`
        ${keyframes}
        animation: collapseAnimation ${duration} ease;
        opacity: 0;
        transition: opacity ${duration};
      `;
};
